<template>
    <form @submit.stop.prevent class="map-adder">
        <span class="mapping-title">{{$t('extra-variables.mapping-title')}}</span>
        <div class="row">
            <custom-input class="col-lg-5 arrow" ref="focusInput" :inputType="'text'" v-model="newMap.string" :name="'newMapString'" :label="$t('extra-variables.if')" :placeholder="$t('extra-variables.if-placeholder')" :focusInputField="focusInput"/>
            <custom-input class="col-lg-6" :inputType="'text'" v-model="newMap.expression" :name="'newMapExpression'" :label="$t('extra-variables.then')" :placeholder="$t('extra-variables.then-placeholder')"/>
            <button type="submit" class="btn col-lg-1" :disabled="!valid" @click="addToMappings">+</button>
        </div>
    </form> 
</template>
<script>
import CustomInput from "@/components/CustomInput";
export default {
  name: "dictionaryAdder",
  data() {
        return {
            addMappingEntry: false,
            newMap: {
                string: "",
                expression: ""
            }
        }
    },
    props:{
        selectedVariable: Object,
        mappings: Array,
        focusInput: Boolean
    },
    methods:{
        addToMappings(){
            let mapEntry = {
                string: this.newMap.string,
                expression: this.newMap.expression
            }
            //  this.mappings.push(mapEntry)
            this.mappings.splice(0, 0, mapEntry)
            this.newMap.string = ''
            this.newMap.expression = ''

        }
    },
    computed:{
        valid(){
            return this.newMap.string && this.newMap.expression
        }
    },
    components:{
        CustomInput
    }
}
</script>

<style lang="less">
   .map-adder{
        margin-top: 12px;
        transition: 0.3s;
        padding: 12px;  
        box-shadow: 2px 4px 4px 2px rgba(0, 0, 0, 0.25); 

        .mapping-title{
            font-size: 14px;
            font-weight: 400;
            color: #8F979C;
            letter-spacing: 0.6px;
            line-height: 25px;
            text-transform: uppercase;
        }

        .btn{
            margin-top: 30px;
            padding-left: 4px;
            color: var(--orange-web);
        &:disabled{
            color:#495057 ;
            }
        }
            .arrow::after{
            content: "→";
            position: absolute;
            right: -8px;
            top: 40px;
        }
    }
    
</style>


